import {LocalStorage} from '../../utils/LocalStorage';

/**
 * Lo que el recorrido recuerda mientras dura la pestaña, fuera de React.
 *
 * Cada paso del túnel es una ruta propia. Que el proveedor sobreviva o no a esa navegación depende
 * de detalles de reconciliación del router que no controlamos ni queremos que nos importen: acá el
 * estado se guarda al lado, así que el recorrido se comporta igual en los dos casos.
 *
 * Guarda dos cosas distintas y por razones distintas:
 *
 * - **Lo que contestó el servidor** (cuentas, propuestas, presupuestos): para no volver a pedir en
 *   cada paso lo que ya se trajo.
 * - **El estado del recorrido**, incluido el resultado del último intento de alta. Ese resultado no
 *   va al borrador —es de este intento, no de la sesión de trabajo— pero tiene que sobrevivir a la
 *   navegación que ocurre entre el error y la pantalla que lo muestra. Sin esto, un alta rechazada
 *   dejaba al usuario en el paso de clientes sin aviso, sin filas marcadas y sin saber qué arreglar.
 *
 * **Lleva de quién son los datos.** Vive mientras viva la pestaña y cerrar sesión no recarga la
 * página: sin la marca, quien entre después con otra cuenta vería la cartera de la anterior.
 */

const EMPTY_SERVER = {candidates: null, proposals: null, budgets: null, period: null, conversionEvents: null};

let serverCache = {...EMPTY_SERVER, ownerKey: null};
let stateCache = {state: null, ownerKey: null};

export function ownerKey() {
    return `${LocalStorage.fetchAgencyId() || ''}:${LocalStorage.fetchUserId() || ''}`;
}

export function cachedServerFor(owner) {
    if (serverCache.ownerKey !== owner) return {...EMPTY_SERVER};
    const {ownerKey: _ignored, ...data} = serverCache;
    return data;
}

export function rememberServer(server, owner) {
    serverCache = {...server, ownerKey: owner};
}

export function cachedStateFor(owner) {
    return stateCache.ownerKey === owner ? stateCache.state : null;
}

export function rememberState(state, owner) {
    stateCache = {state, ownerKey: owner};
}

/** Se olvida de todo. Lo llama el final del recorrido: lo que sigue ya no es este armado. */
export function clearWizardMemory() {
    serverCache = {...EMPTY_SERVER, ownerKey: null};
    stateCache = {state: null, ownerKey: null};
}
